import PatchController from '../PatchController';

export default class ProgramsRecommendedController extends PatchController {
	public handle() {
		this.redirect(this.routes.program.recommended.href);
	}
}
